export const EXAM_SCHEDULE_DATA = {
  "data": [
    {
      "course_number": "ACCT110",
      "course_title": "Introduction to Financial Accounting",
      "time": "8:00",
      "date": "19-May-2025",
      "day": "Monday",
      "location": "57-219 (Males); 57-221 (Females)",
      "period": "19",
      "term_code": "202420"
    },
    // Add more real exam data here from the API
  ]
};